"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var ResultsService_1 = __importDefault(require("./ResultsService"));
var TemplateTiles_1 = __importDefault(require("./TemplateTiles/TemplateTiles"));
var TemplateUnits_1 = __importDefault(require("./TemplateUnits/TemplateUnits"));
var TemplatesTypes_1 = require("Templates/TemplatesTypes");
var TemplateThumbnails_1 = __importDefault(require("./TemplateThumbnails/TemplateThumbnails"));
var ViewAllTemplatesButton_1 = require("./ViewAllTemplatesButton");
var Results = (function () {
    function Results(createUi, make, templateState, updateTemplateState, mountReactComponent) {
        var _this = this;
        var currentTemplateState;
        var selectTemplate = function (message, template, tileId) {
            var newTemplateState = lodash_1.default.cloneDeep(currentTemplateState);
            newTemplateState.projectId = template.projectId;
            if (tileId) {
                newTemplateState.tile = tileId;
            }
            updateTemplateState(newTemplateState, message);
        };
        var handleViewAllTemplatesBtnClick = function () {
            templateState.dropdownItem = "all";
            updateTemplateState(templateState);
        };
        this.refresh = function (newTemplateState) {
            if (currentTemplateState &&
                currentTemplateState.dropdownItem === newTemplateState.dropdownItem &&
                currentTemplateState.searchTerm === newTemplateState.searchTerm &&
                currentTemplateState.useCase === newTemplateState.useCase) {
                return;
            }
            currentTemplateState = lodash_1.default.cloneDeep(newTemplateState);
            var getResults = make(ResultsService_1.default, {
                templateState: newTemplateState,
            }).getResults;
            var results = getResults();
            if ((0, TemplatesTypes_1.isSingleResult)(results)) {
                var templateUnits = make(TemplateUnits_1.default, {
                    results: results.results,
                    selectTemplate: selectTemplate,
                    templateState: newTemplateState,
                });
                _this._ui.results = templateUnits.ui;
            }
            else if ((0, TemplatesTypes_1.isThumbnailResult)(results)) {
                var templateThumbnails = make(TemplateThumbnails_1.default, {
                    results: results.results,
                    selectTemplate: selectTemplate,
                    templateState: newTemplateState,
                });
                _this._ui.results = templateThumbnails.ui;
            }
            else {
                var templateTiles = make(TemplateTiles_1.default, {
                    results: results.results,
                    selectTemplate: selectTemplate,
                    templateState: newTemplateState,
                });
                _this._ui.results = templateTiles.ui;
            }
            _this._ui.viewAllTemplatesBtn = "";
            if (templateState.dropdownItem === "recommended") {
                _this._ui.viewAllTemplatesBtn = (0, ViewAllTemplatesButton_1.mountViewAllTemplatesButton)(mountReactComponent, handleViewAllTemplatesBtnClick);
            }
        };
        this._ui = createUi(require("./Results.html"));
        if (templateState.dropdownItem || templateState.searchTerm != null) {
            this.refresh(templateState);
        }
    }
    Object.defineProperty(Results.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return Results;
}());
exports.default = Results;
